import { render, staticRenderFns } from "./studentAttendanceSubject.vue?vue&type=template&id=04c0c944&scoped=true&"
import script from "./studentAttendanceSubject.vue?vue&type=script&lang=js&"
export * from "./studentAttendanceSubject.vue?vue&type=script&lang=js&"
import style0 from "./studentAttendanceSubject.vue?vue&type=style&index=0&id=04c0c944&lang=scss&scoped=true&"
import style1 from "./studentAttendanceSubject.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./studentAttendanceSubject.vue?vue&type=style&index=2&id=04c0c944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c0c944",
  null
  
)

export default component.exports